import { BlockModule } from '../common'
import { tailwindBreakpoints } from '../tailwind'

new BlockModule({
    selector: '.block-reviews-card-carousel',
    async setupBlock(el, onTeardown) {
        let isSwiperInit = false
        const swiperContainer = el.querySelector('.swiper') as HTMLElement

        if (!swiperContainer) return

        const [{ Swiper }, { Scrollbar }] = await Promise.all([
            import('swiper'),
            import('swiper/modules'),
            // @ts-ignore
            import('swiper/css'),
            // @ts-ignore
            import('swiper/css/scrollbar'),
        ])

        const slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide')) as HTMLElement[] || []
        const slidesCount = slides.length

        if (slidesCount <= 1) return

        const scrollbarEl = el.querySelector('.swiper-scrollbar') as HTMLElement

        const swiper = new Swiper(swiperContainer, {
            modules: [Scrollbar],
            slidesPerView: 1.2,
            // slidesPerGroup: slidesCount / 1.2,
            spaceBetween: 16,
            scrollbar: {
                el: scrollbarEl,
                draggable: true,
            },
            breakpoints: {
                [tailwindBreakpoints.md]: {
                    slidesPerView: 1.6,
                    spaceBetween: 20,
                    // slidesPerGroup: slidesCount / 1.6
                },
                [tailwindBreakpoints['2xl']]: {
                    slidesPerView: 2.5,
                    slidesPerGroup: slidesCount / 2.5
                },
                [tailwindBreakpoints['3xl']]: {
                    slidesPerView: 2.8,
                    slidesPerGroup: slidesCount / 2.8
                },
            },
        })

        isSwiperInit = true

        const slideElements = Array.from(el.querySelectorAll('.swiper-slide'))
        if (slideElements.length === 0) return

        onTeardown(() => {
            swiper.destroy()
        })
    },
})
